export const GATE_PRICING = {
  pricePerSession: 77,
  sessionHours: 3,
  sessionsPerTerm: 10,
  bookletsPerTerm: 5,
  bookletsCost: 49,
  included: 'Practice tests, explanations and reports',
} as const;

export const GATE_TERM_TUITION = GATE_PRICING.pricePerSession * GATE_PRICING.sessionsPerTerm;
export const GATE_TERM_TOTAL = GATE_TERM_TUITION + GATE_PRICING.bookletsCost;
